<template>
  <div class="app">
    <h1>信息化建设</h1>
    <Header :activeIndex="'1-1'"/>

    <main class="margintop">
      <section>
        <div class="biaoti">1.工作流管理系统</div>
        <div class="content">(1) 任务创建分发：帮助团队成员快速创建、分配和管理任务，确保每个人物都有明确的负责人和截止日期，提高工作效率。</div>
        <div class="content">(2) 进度跟进：实时监控任务进度，及时了解每个任务的完成情况，确保项目按时推进。</div>
      </section>
      <section>
        <div class="biaoti">2.CRM管理系统</div>
        <div class="content">(1) 客户信息管理：集中管理客户的基本信息、沟通历史和需求，帮助团队更好地了解客户需求，提升客户满意度。</div>
        <div class="content">(2) 客户跟进追踪：跟踪客户的每一步进展，确保每个客户都得到及时的关注和服务，避免漏掉潜在商机。</div>
      </section>
      <section>
        <div class="biaoti">3.企业信息库</div>
        <div class="content">(1) 千万条企业数据：提供庞大的企业数据库，帮助用户查找目标企业的详细信息，拓展业务发展空间</div>
        <div class="content">(2) 一键拨打电话：支持一键拨打电话功能，让用户直接联系企业负责人或相关人员，简化沟通流程。</div>
      </section>
      <section>
        <div class="biaoti">4.出版大师</div>
        <div class="content">(1) 出版审核流管理：系统化管理出版过程中的各项审核流程，确保每个环节都能高效流畅地完成。</div>
        <div class="content">(2) 智能协作跟进：通过智能化的协作工具，使团队成员能够高效写作并跟进出版项目的各项进展，提升工作效率。</div>
      </section>
      <section>
        <div class="biaoti">5.定制开发</div>
        <div class="content">(1) 网站开发：为客户量身定制网站设计与开发，帮助企业打造符合品牌特色、用户体验良好的官方网站。</div>
        <div class="content">(2) 小程序建设：根据需求开发个性化的小程序，帮助企业实现微信生态内的数字化服务。</div>
        <div class="content">(3) APP设计与开发：设计和开发高性能的APP，满足不同平台用户的需求，提升企业移动端用户体验。</div>
        <div class="content">(4) 系统设计与搭建：根据企业特定需求设计并搭建高效的管理系统，帮助优化业务流程，提升管理效率。</div>
        <div class="content">(5) AI系统设计与开发：利用人工智能技术，为企业定制智能化的系统解决方案，提升决策效率和业务自动化水平。</div>
      </section>
    </main>

    <Youshi />
    <Footer />
  </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Youshi from '@/components/Youshi.vue'

export default {
  name: 'xinxi',
  components: {
    Header,
    Footer,
    Youshi
  },
  data() {
    return {
      imgCount: 0,
      currentIndex: 0,
      intervalID: '',
      // showData: true,
      pppclose: true,
      row1: ['注册<br>公司', '不续费<br>地址', '代理<br>记账', '社保<br>托管', '刻章<br>补照'],
      row2: ['变更<br>注销', '审计<br>咨询', '资质<br>许可', '商标<br>软著', '税务<br>筹划']
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    // console.log(this.$root.showData.showData);
    this.$root.showData.showData = false;
  },
  methods: {
    formatText(text) {
      return text;
    },
    pppopco() {
      this.$root.ppp.ppp = !this.$root.ppp.ppp
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathRemen() {
      this.$router.push('/remen');
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathcontact() {
      this.$router.push('/contact')
    },
    pathxinxi() {
      this.$router.push('/xinxi')
    },
  }
}
</script>

<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {
  .responsive-carousel el-carousel el-carousel--horizontal {
    height: 128px !important;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }

  .el-menu--horizontal>.el-menu-item {
    float: left;
    height: 30px !important;
    line-height: 30px !important;
    margin: 0;
  }
}
</style>

<style scoped>
h1 {
  font-size: 0%;
}

.biaoti {
  font-size: 20px;
  font-weight: 700;
  margin-top: 10px;
  line-height: 30px;
}

.content {
  font-size: 17px;
  line-height: 35px;
}

.margintop {
  text-align: left;
  margin-left: 25%;
  margin-right: 25%;
  font-size: 25px;
  margin-top: 118px;
  font-weight: 500;
}

@media (max-width: 768px) {
  /* 图片 */
  .biaoti {
    font-size: 15px;
    font-weight: 700;
  }

  .content {
    margin-top: 5px;
    color: black;
    line-height: normal;
    font-size: 13px;
    font-weight: 400;
  }
  
  /* 其他 */
  .margintop {
    margin-top: 100px;
    text-align: left;
    margin-left: auto;
    margin-right: auto;
    font-size: 15px;
    margin-left: 2%;
    margin-right: 2%;
    margin-bottom:5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/xinxi.vue